import { apiClient } from "@services/apiClient";
import { ATP_API_URL } from "@config/apiconfig";

export const submitAmountData = async (requestBody) => {
  try {
    let url = ATP_API_URL.ADD_CD_BALANCE;
    const response = await apiClient.post(url, requestBody);

    if (response?.data?.status) {
      return response.data;
    }
  } catch (error) {
    console.error("Error submitting data:", error);
    throw error;
  }
};

export const verifyOtpAddCdBalance = async (requestBody) => {
  try {
    let url = ATP_API_URL.VERIFY_ADD_CD_BALANCE;
    const response = await apiClient.post(url, requestBody);

    if (response?.data?.status) {
      return response.data;
    }
  } catch (error) {
    console.error("Error submitting data:", error);
    throw error;
  }
};
